module.exports = __webpack_public_path__ + "assets/dimdi_logo.e528fbc2.png";